export default __webpack_public_path__ + "static/media/22t.85cbb19b.jpg";